define('models/ConversationSummary',[
    'lib/knockout',
    'util/ObservableModel'
], function (ko, ObservableModel) {
    'use strict';

    var Conversation = ObservableModel.extend({}, function () {});
    return Conversation;
});

